import { render } from "./HubHighlightDetailView.vue?vue&type=template&id=655c36df&ts=true"
import script from "./HubHighlightDetailView.vue?vue&type=script&lang=ts"
export * from "./HubHighlightDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__